module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-view', {
    key: _vm.$route.fullPath
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d3569280!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Root.vue
// module id = 1176
// module chunks = 23